import type { Apartment, ApartmentCategory } from "../types";

const apartmentImage = (room: string, file: string) => `/assets/apartments/${room}/${file}`;
const apartmentGallery = (room: string, files: string[]) => files.map((file) => apartmentImage(room, file));

const buildingAccess = "Building Access: Access is provided through Front & Rear - Locked doors.";
const parking = "Parking: A large Parking Lot is located in Rear of building and can accommodate your vehicle and/or trailer.";
const sharedAmenities = ["Laundry Room", "Close to Fishing", "Air Conditioning"];

const kitchenNeeds = "The Kitchen is fully stocked with all your kitchen needs (i.e. pots, pans, dishes, silverware, glassware, blender, coffee maker, etc.)";

const gallery1g = apartmentGallery("1g", [
  "DSC09841-1.jpg",
  "DSC09771.jpg",
  "DSC09773.jpg",
  "DSC09774.jpg",
  "DSC09775.jpg",
  "DSC09823.jpg",
  "DSC09827.jpg",
  "DSC09827-1.jpg",
  "DSC09833.jpg",
  "DSC09840.jpg",
  "DSC09841.jpg",
  "DSC09844-1.jpg",
  "DSC09846.jpg",
  "DSC09848.jpg",
  "DSC09849.jpg",
  "DSC09858.jpg",
  "DSC09863.jpg",
  "DSC09870.jpg",
  "DSC09872.jpg",
]);

const gallery1c = apartmentGallery("1c", [
  "DSC09781.jpg",
  "DSC09786.jpg",
  "DSC09783.jpg",
  "DSC09785.jpg",
  "DSC09786-1.jpg",
  "DSC09792.jpg",
  "DSC09794.jpg",
  "DSC09800.jpg",
  "DSC09803.jpg",
  "DSC09808.jpg",
  "DSC09810.jpg",
  "DSC09813.jpg",
  "DSC09815.jpg",
]);

const galleryPenthouse = apartmentGallery("penthouse", [
  "DSC00254.jpg",
  "IMG_0773.jpg",
  "IMG_0774.jpg",
  "DSC00234.jpg",
  "DSC00238.jpg",
  "DSC00241.jpg",
  "DSC00245.jpg",
  "DSC00250.jpg",
  "DSC00264.jpg",
  "DSC00266.jpg",
  "DSC00268.jpg",
  "DSC00270.jpg",
  "DSC00276.jpg",
  "DSC00280.jpg",
]);

const gallery1d = apartmentGallery("1d", [
  "IMG_6126-1-scaled.jpg",
  "IMG_6128-1-scaled.jpg",
  "IMG_6125-scaled.jpg",
  "IMG_6126-2-scaled.jpg",
  "IMG_6127-scaled.jpg",
  "IMG_6128-2-scaled.jpg",
]);

const gallery2a = apartmentGallery("2a", ["DSC00036.jpg", "DSC00006.jpg"]);

const gallery2b = apartmentGallery("3bedroom2b", [
  "DSC09899.jpg",
  "DSC09880.jpg",
  "DSC09882.jpg",
  "DSC09893.jpg",
  "DSC09910.jpg",
  "DSC09917.jpg",
  "DSC09920.jpg",
  "DSC09928.jpg",
  "DSC09933.jpg",
  "DSC09934.jpg",
  "DSC09937.jpg",
  "DSC09946.jpg",
  "DSC09949.jpg",
  "DSC09955.jpg",
  "DSC09957.jpg",
  "DSC09958.jpg",
  "DSC09961.jpg",
  "DSC09965.jpg",
  "DSC09966.jpg",
  "DSC09970.jpg",
  "DSC09972.jpg",
  "DSC09986.jpg",
]);

const gallerySpace = apartmentGallery("ag", ["art-Galery-.png"]);
const futureStudioGallery = ["/assets/site/clean-building-image.png", "/assets/site/building-entry.jpg"];
const futureOneBedroomGallery = ["/assets/site/building-entry.jpg", "/assets/site/clean-building-image.png"];
const futureFlexGallery = ["/assets/site/exterior.png", "/assets/site/building-entry.jpg"];

export const apartments: Apartment[] = [
  {
    slug: "1g",
    wpBookingSlug: "1g",
    title: "1G - Studio",
    category: "Studio",
    priceNight: 149,
    sleeps: 1,
    bedrooms: 0,
    beds: "Single Pull-Out Bed / Couch",
    bathrooms: "Full Bathroom",
    kitchen: "Full Kitchen",
    status: "available",
    summary: "A fully furnished, turnkey studio apartment.",
    descriptionHeading: "Apartment description",
    description: [
      "This unit is a fully furnished, turnkey studio apartment.",
      "Unit has a Couch with Single Pull-Out Bed.",
      kitchenNeeds,
      "The Bathroom has a Shower and all needed towels.",
    ],
    amenities: [buildingAccess, parking, "Single Pull-Out Bed / Couch", ...sharedAmenities],
    reserveLabel: "Reserve this apartment",
    listingActionLabel: "Book Room",
    youtubeVideoId: "5qEYTDWxn70",
    featuredImage: gallery1g[0],
    gallery: gallery1g,
    alt: "1G - Studio",
  },
  {
    slug: "1c",
    wpBookingSlug: "1c",
    title: "1C - 1 Bedroom",
    category: "1 Bedroom",
    priceNight: 229,
    sleeps: 2,
    bedrooms: 1,
    beds: "1 Queen Size Bed",
    bathrooms: "Full Bathroom",
    kitchen: "Full Kitchen",
    status: "available",
    summary: "A fully furnished, turnkey one-bedroom apartment.",
    descriptionHeading: "Apartment description",
    description: [
      "This unit is a fully furnished, turnkey one-bedroom apartment.",
      "The Bedroom has a Queen-size bed.",
      kitchenNeeds,
      "Bathroom has a Tub / Shower and has all needed towels.",
    ],
    amenities: [buildingAccess, parking, "1 Queen Size Bed", ...sharedAmenities],
    reserveLabel: "Reserve this apartment",
    listingActionLabel: "More info",
    youtubeVideoId: "rumJTTFchbI",
    featuredImage: gallery1c[0],
    gallery: gallery1c,
    alt: "1C - 1 Bedroom",
  },
  {
    slug: "1g-2",
    wpBookingSlug: "1g-2",
    title: "Future Studio Residence",
    category: "Future Space",
    beds: "Configuration to be announced",
    bathrooms: "Private bath planned",
    kitchen: "Kitchen plan in review",
    status: "non-bookable",
    summary: "A future furnished studio is being planned inside The Deposit Seed House.",
    descriptionHeading: "Future residence",
    description: [
      "This space is not accepting reservations yet.",
      "Join the guest update list or contact us if you would like to hear when additional furnished units are ready.",
    ],
    amenities: [buildingAccess, parking, ...sharedAmenities],
    reserveLabel: "Ask about future availability",
    listingActionLabel: "Preview space",
    featuredImage: futureStudioGallery[0],
    gallery: futureStudioGallery,
    alt: "The Deposit Seed House exterior",
  },
  {
    slug: "penthouse",
    wpBookingSlug: "penthouse",
    title: "3A - PENTHOUSE",
    detailTitle: "3A - PENTHOUSE",
    category: "1 Bedroom",
    priceNight: 249,
    sleeps: 2,
    bedrooms: 1,
    beds: "1 Queen Bed",
    bathrooms: "Full Bathroom",
    kitchen: "Full Kitchen",
    status: "available",
    summary: "A fully furnished, turnkey penthouse apartment.",
    descriptionHeading: "Penthouse description",
    description: [
      "This unit is a fully furnished, turnkey one-bedroom penthouse apartment.",
      "The Bedroom has a Queen-size bed.",
      kitchenNeeds,
      "Bathroom has a Tub / Shower and has all needed towels.",
    ],
    amenities: [buildingAccess, parking, "1 Queen Bed", ...sharedAmenities],
    reserveLabel: "Reserve the Penthouse",
    listingActionLabel: "More info",
    youtubeVideoId: "LLI2-4s6fe0",
    featuredImage: galleryPenthouse[0],
    gallery: galleryPenthouse,
    alt: "3A - PENTHOUSE",
  },
  {
    slug: "ag",
    wpBookingSlug: "ag",
    title: "Gallery",
    detailTitle: "3A - Gallery",
    category: "Gallery",
    bathrooms: "Full Bathroom",
    kitchen: "Full Kitchen",
    beds: "Gallery Space",
    status: "non-bookable",
    summary: "A light-filled gallery-style space is available for inquiries, previews, and future use discussions.",
    descriptionHeading: "Gallery description",
    description: [
      "The original attic and designated factory recreation room has been transformed into a spectacular open space.",
      "The original factory flooring has been restored with a gymnasium-style luster that enhances the room.",
      "Approximately 20 windows bring in a generous amount of natural light.",
      "A 10-foot ceiling fan helps cool the entire space.",
      "Four main trusses span the building, preserving original wood framing and a 24-foot ridge-to-center floor height.",
      "The entire area features closed-cell foam with an intumescent coating to help maintain heating and cooling conditions.",
      "Contact us to discuss viewing this space for gallery, photography, studio, or other creative uses.",
    ],
    amenities: [buildingAccess, parking, "Close to Fishing", "Laundry Room", "Ceiling Fan"],
    reserveLabel: "Contact us for more information",
    listingActionLabel: "More info",
    youtubeVideoId: "PCg8sigc1Xw",
    featuredImage: gallerySpace[0],
    gallery: gallerySpace,
    alt: "Gallery",
  },
  {
    slug: "1d",
    wpBookingSlug: "1d",
    title: "1D - 1 Bedroom",
    category: "1 Bedroom",
    priceNight: 229,
    sleeps: 2,
    bedrooms: 1,
    beds: "1 Queen Size Bed",
    bathrooms: "Full Bathroom",
    kitchen: "Full Kitchen",
    status: "available",
    summary: "A fully furnished, turnkey one-bedroom apartment.",
    descriptionHeading: "Apartment description",
    description: [
      "This unit is a fully furnished, turnkey one-bedroom apartment.",
      "The Bedroom has a Queen-size bed.",
      kitchenNeeds,
      "The Bathroom has a Tub / Shower and has all needed towels.",
    ],
    amenities: [buildingAccess, parking, "1 Queen Size Bed", ...sharedAmenities],
    reserveLabel: "Reserve this apartment",
    listingActionLabel: "More info",
    detailNote: "Full photo gallery available; contact us if you would like additional arrival details before booking.",
    featuredImage: gallery1d[0],
    gallery: gallery1d,
    alt: "1D - 1 Bedroom",
  },
  {
    slug: "2a",
    wpBookingSlug: "2a",
    title: "2A - 2 Bedroom",
    category: "2 Bedrooms",
    priceNight: 299,
    sleeps: 4,
    bedrooms: 2,
    beds: "1 Queen and 1 Full Size Bed",
    bathrooms: "Full Bathroom",
    kitchen: "Full Kitchen",
    status: "available",
    summary: "A fully furnished, turnkey two-bedroom apartment.",
    descriptionHeading: "Apartment Description",
    description: [
      "This unit is a fully furnished, turnkey two-bedroom apartment.",
      "The Master Bedroom has a Queen-size bed, while the other bedroom has a Full-size bed.",
      kitchenNeeds,
      "Bathroom has a Tub / Shower and has all needed towels.",
    ],
    amenities: [buildingAccess, parking, "1 Queen and 1 Full Size Bed", ...sharedAmenities],
    reserveLabel: "Reserve this Apartment",
    listingActionLabel: "More info",
    youtubeVideoId: "zNqVpHh9tAw",
    featuredImage: gallery2a[0],
    gallery: gallery2a,
    alt: "2A - 2 Bedroom",
  },
  {
    slug: "3bedroom2b",
    wpBookingSlug: "3bedroom2b",
    title: "2B - 3 Bedroom",
    category: "3 Bedrooms",
    priceNight: 349,
    sleeps: 6,
    bedrooms: 3,
    beds: "1 Queen & 2 Full Size Beds",
    bathrooms: "Full Bathroom",
    kitchen: "Full Kitchen",
    status: "available",
    summary: "A fully furnished, turnkey three-bedroom apartment.",
    descriptionHeading: "Apartment description",
    description: [
      "This unit is a fully furnished, turnkey three-bedroom apartment.",
      "The Master Bedroom has a Queen-size bed, while the other (2) bedrooms are Full-size.",
      kitchenNeeds,
      "Bathroom has a Tub / Shower and has all needed towels.",
    ],
    amenities: [buildingAccess, parking, "1 Queen & 2 Full Size Beds", "Laundry Room", "Close to Fishing", "Air Conditioning"],
    reserveLabel: "Reserve this Apartment",
    listingActionLabel: "More info",
    youtubeVideoId: "xiMC32aOnMk",
    featuredImage: gallery2b[0],
    gallery: gallery2b,
    alt: "2B - 3 Bedroom",
  },
  {
    slug: "2a-2",
    wpBookingSlug: "2a-2",
    title: "Future One-Bedroom Residence",
    category: "Future Space",
    beds: "Configuration to be announced",
    bathrooms: "Private bath planned",
    kitchen: "Kitchen plan in review",
    status: "non-bookable",
    summary: "A future one-bedroom furnished stay is planned as the building continues to evolve.",
    descriptionHeading: "Future residence",
    description: [
      "This residence is in planning and is not bookable yet.",
      "Contact us or join the guest update list for opening notes, seasonal availability, and direct-booking updates.",
    ],
    amenities: [buildingAccess, parking, ...sharedAmenities],
    reserveLabel: "Ask about future availability",
    listingActionLabel: "Preview space",
    featuredImage: futureOneBedroomGallery[0],
    gallery: futureOneBedroomGallery,
    alt: "The Deposit Seed House front entry at night",
  },
  {
    slug: "2a-2-2",
    wpBookingSlug: "2a-2-2",
    title: "Future Flexible Stay",
    category: "Future Space",
    beds: "Configuration to be announced",
    bathrooms: "Private bath planned",
    kitchen: "Kitchen plan in review",
    status: "non-bookable",
    summary: "A future flexible furnished stay is being evaluated for guests who need a longer Deposit visit.",
    descriptionHeading: "Future residence",
    description: [
      "This space is being planned for a future release and is not currently accepting booking requests.",
      "Reach out if you are planning a longer stay and want to be notified as new furnished options become available.",
    ],
    amenities: [buildingAccess, parking, ...sharedAmenities],
    reserveLabel: "Ask about future availability",
    listingActionLabel: "Preview space",
    featuredImage: futureFlexGallery[0],
    gallery: futureFlexGallery,
    alt: "The Deposit Seed House exterior",
  },
];

export const apartmentCategories: Array<ApartmentCategory | "All"> = ["All", "Studio", "1 Bedroom", "2 Bedrooms", "3 Bedrooms", "Future Space", "Gallery"];

export const bookableApartments = apartments.filter((apartment) => apartment.status !== "non-bookable");

export function getApartment(slug: string | undefined) {
  return apartments.find((apartment) => apartment.slug === slug);
}
